import { EntityModules } from 'core/constants';

import { LibraryEntityType } from 'utils/api/modules/entities/entities.types';

const LIBRARY_ID_PREFIX: Record<LibraryEntityType, string> = {
  [EntityModules.Controls]: 'CTL',
  [EntityModules.Hazards]: 'HAZ',
};

const LIBRARY_ID_DIGITS = 4;

export const formatLibraryId = (entityType: LibraryEntityType, id: number | null | undefined): string =>
  id === null || id === undefined
    ? ''
    : `${LIBRARY_ID_PREFIX[entityType]}-${String(id).padStart(LIBRARY_ID_DIGITS, '0')}`;
